module.exports = __webpack_public_path__ + "img/all.236ab888.png";